/**
 * A failed findings read, in place of its table (mission 6 WP08 T044; FR-012,
 * FR-014, FR-015; contracts/ui-api.md "Paging" and "Problems").
 *
 * A cursor the API did not issue (400 with `errors[].field === "cursor"`)
 * renders register 16's `backToFirstPage` ("Back to the first page", owner decision
 * 2026-09-26), which resets the paging to the first page. Any other
 * problem renders through `ProblemBand`; anything that is not a problem (a
 * transport failure) renders the generic error sentence.
 */
import { Band } from '@/components/trellis/Band'
import { ProblemBand } from '@/components/trellis/ProblemBand'
import { Button } from '@/components/ui/button'
import { ApiError } from '@/lib/api'
import { copyText } from '@/lib/provisional-copy'

export function isCursorRefusal(error: unknown): boolean {
  return (
    error instanceof ApiError &&
    error.problem.status === 400 &&
    (error.problem.errors ?? []).some((e) => e.field === 'cursor')
  )
}

/** `onStartAgain` resets a paged view; an unpaged view (the trailer) passes none. */
export function ReadError({ error, onStartAgain }: { error: unknown; onStartAgain?: () => void }) {
  if (onStartAgain && isCursorRefusal(error)) {
    return (
      <Band
        kind="info"
        action={
          <Button variant="secondary" size="sm" onClick={onStartAgain}>
            {copyText('backToFirstPage')}
          </Button>
        }
      >
        {copyText('genericError')}
      </Band>
    )
  }
  if (error instanceof ApiError) return <ProblemBand problem={error.problem} />
  return <Band kind="blocked">{copyText('genericError')}</Band>
}
